// einrueckung.js — Tab und Shift-Tab rücken um zwei Leerzeichen ein.
//
// Zwei Leerzeichen, nicht vier: vier lösen im Markdown einen Codeblock aus.
// Der Code stammt aus `shortcuts-expansion.js`, das am 17.09.2026 mit den
// Text-Shortcuts entfallen ist — die Einrückung hing nur mit im selben Modul.

import { keymap } from "@codemirror/view";

const EINZUG = "  ";

// Mehrzeilige Auswahl: jede Zeile bekommt den Einzug.
function zeilenEinruecken(view) {
  const state = view.state;
  const auswahl = state.selection.main;
  if (auswahl.empty) return false;

  const vonZeile = state.doc.lineAt(auswahl.from);
  const bisZeile = state.doc.lineAt(auswahl.to);
  if (vonZeile.number === bisZeile.number) return false;

  const changes = [];
  for (let i = vonZeile.number; i <= bisZeile.number; i++) {
    changes.push({ from: state.doc.line(i).from, insert: EINZUG });
  }
  view.dispatch({ changes });
  return true;
}

function zeilenAusruecken(view) {
  const state = view.state;
  const auswahl = state.selection.main;
  const vonZeile = state.doc.lineAt(auswahl.from);
  const bisZeile = state.doc.lineAt(auswahl.empty ? auswahl.from : auswahl.to);

  const changes = [];
  for (let i = vonZeile.number; i <= bisZeile.number; i++) {
    const zeile = state.doc.line(i);
    const treffer = zeile.text.match(/^( {1,2}|\t)/);
    if (treffer) {
      changes.push({ from: zeile.from, to: zeile.from + treffer[0].length, insert: "" });
    }
  }
  if (changes.length === 0) return false;
  view.dispatch({ changes });
  return true;
}

export function einrueckungExtension() {
  return keymap.of([
    {
      key: "Tab",
      run: (view) => {
        if (zeilenEinruecken(view)) return true;
        const kopf = view.state.selection.main.head;
        view.dispatch({
          changes: { from: kopf, insert: EINZUG },
          selection: { anchor: kopf + EINZUG.length },
        });
        return true;
      },
    },
    {
      key: "Shift-Tab",
      run: (view) => zeilenAusruecken(view),
    },
  ]);
}
